__turbopack_context__.v({
  "contrast": "Tooltip-module__Msunqa__contrast",
  "default": "Tooltip-module__Msunqa__default",
  "overlayArrow": "Tooltip-module__Msunqa__overlayArrow",
  "tooltip": "Tooltip-module__Msunqa__tooltip",
});
